
import { useState, useEffect } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-slate-900/80 backdrop-blur-md border-b border-white/10 shadow-lg' 
        : 'bg-transparent'
    }`}>
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
              <i className="ri-code-s-slash-line text-white text-xl"></i>
            </div>
            <h1 className="text-2xl font-bold">
              <span className="text-white font-family: 'Pacifico', serif;">MPG System</span>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-white/80 hover:text-white transition-colors duration-300 font-medium"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('sobre')}
              className="text-white/80 hover:text-white transition-colors duration-300 font-medium"
            >
              Sobre
            </button>
            <button 
              onClick={() => scrollToSection('solucoes')}
              className="text-white/80 hover:text-white transition-colors duration-300 font-medium"
            >
              Soluções
            </button>
            <button 
              onClick={() => scrollToSection('produtos')}
              className="text-white/80 hover:text-white transition-colors duration-300 font-medium"
            >
              Produtos
            </button>
            <button 
              onClick={() => scrollToSection('clientes')}
              className="text-white/80 hover:text-white transition-colors duration-300 font-medium"
            >
              Clientes
            </button>
            <button 
              onClick={() => scrollToSection('depoimentos')}
              className="text-white/80 hover:text-white transition-colors duration-300 font-medium"
            >
              Depoimentos
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="text-white/80 hover:text-white transition-colors duration-300 font-medium"
            >
              Contato
            </button>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              variant="primary" 
              onClick={() => scrollToSection('contato')}
              icon="ri-phone-line"
            >
              Fale Conosco
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2 rounded-lg hover:bg-white/10 transition-colors"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 p-4 bg-slate-900/90 backdrop-blur-md rounded-2xl border border-white/10">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-white/80 hover:text-white transition-colors duration-300 font-medium text-left py-2"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('sobre')}
                className="text-white/80 hover:text-white transition-colors duration-300 font-medium text-left py-2"
              >
                Sobre
              </button>
              <button 
                onClick={() => scrollToSection('solucoes')}
                className="text-white/80 hover:text-white transition-colors duration-300 font-medium text-left py-2"
              >
                Soluções
              </button>
              <button 
                onClick={() => scrollToSection('produtos')}
                className="text-white/80 hover:text-white transition-colors duration-300 font-medium text-left py-2"
              >
                Produtos
              </button>
              <button 
                onClick={() => scrollToSection('clientes')}
                className="text-white/80 hover:text-white transition-colors duration-300 font-medium text-left py-2"
              >
                Clientes
              </button>
              <button 
                onClick={() => scrollToSection('depoimentos')}
                className="text-white/80 hover:text-white transition-colors duration-300 font-medium text-left py-2"
              >
                Depoimentos
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="text-white/80 hover:text-white transition-colors duration-300 font-medium text-left py-2"
              >
                Contato
              </button>
              <div className="pt-4 border-t border-white/10">
                <Button 
                  variant="primary" 
                  onClick={() => scrollToSection('contato')}
                  icon="ri-phone-line"
                  className="w-full"
                >
                  Fale Conosco
                </Button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
